import { useEffect, useState } from "react"
import { GRADIENT_DISTINATION, GRADIENT_TYPE, IGradient, parseGradient } from "src/libs/utilities/colors"
import GradientHandler from "./GradientHandler"
import GradientDistination from "./GradientDistination"
import GradientType from "./GradientType"


const GradientExample = ({value, field, onChange}: any) : JSX.Element => { 
    const [data, setData] = useState<IGradient>(parseGradient(value)) 
    useEffect(() => {
        setData( parseGradient(value) )
    }, [value])
    // console.log(value, data)
    const  onDistination = (distination: string) => {

    }
    const onType = ( ) => {
        const next = ( ) => {
            return {
                [GRADIENT_TYPE.LINEAR] : GRADIENT_TYPE.RADIAL,
                [GRADIENT_TYPE.RADIAL] : GRADIENT_TYPE.LINEAR,
            }
        }
        let _data = {...data}
        _data.type = next()[ data.type || GRADIENT_TYPE.LINEAR ]
        setData(_data)
    }
    return <>
        <GradientHandler data={data} />
        <GradientDistination distination={ data.line || GRADIENT_DISTINATION.TO_LEFT } onClick={onDistination}/>
        <GradientType type={ data.type || GRADIENT_TYPE.LINEAR } onClick={onType} />
    </> 
}

export default GradientExample